import { AnyAction } from 'redux';
import dayjs from 'dayjs';
import * as actionTypes from '../actions/actionTypes';

export const filterOptions = {
  types: 'types',
  directions: 'directions',
  extensions: 'extensions',
  tags: 'tags',
  queues: 'queues',
  dateRange: 'dateRange',
  searchFor: 'searchFor',
};

export interface DateRange {
  start: string | null;
  end: string | null;
}

interface HistoryFilterOptions {
  selectedTab: string[];
  types: string[];
  directions: string[];
  extensions: number[];
  tags: number[];
  queues: number[];
  dateRange: DateRange;
  resetCallItems: boolean;
  hasDateRange: boolean;
  searchFor: string | null;
  pageOffset: number;
}

const initialState: HistoryFilterOptions = {
  selectedTab: ['My Calls'],
  types: [],
  directions: [],
  extensions: [],
  tags: [],
  queues: [],
  dateRange: {
    start: dayjs()
      .subtract(1, 'day')
      .startOf('day')
      .format('YYYY-MM-DD HH:mm:ss'),
    end: dayjs()
      .endOf('day')
      .format('YYYY-MM-DD HH:mm:ss'),
  },
  resetCallItems: false,
  hasDateRange: false,
  searchFor: null,
  pageOffset: 1,
};

const reducer = (
  state: HistoryFilterOptions = initialState,
  action: AnyAction
): HistoryFilterOptions => {
  switch (action.type) {
    case actionTypes.SET_HISTORY_FILTER_OPTIONS:
      return {
        ...state,
        ...action.extra,
        dateRange: state.hasDateRange
          ? state.dateRange
          : initialState.dateRange,
        [action.option]: action.payload,
        pageOffset: 1,
      };
    case actionTypes.CLEAR_HISTORY_CUSTOM_FILTERS:
      return {
        ...initialState,
        resetCallItems: true,
      };
    case actionTypes.SET_CURRENT_HISTORY_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };
    case actionTypes.SET_CALL_LOGS_PAGE_OFFSET:
      return {
        ...state,
        pageOffset: action.payload.pageOffset,
      };
    case actionTypes.RESET_CALL_ITEMS:
      return {
        ...state,
        resetCallItems: action.payload,
      };
    case actionTypes.RESET_HISTORY_FILTER_OPTIONS:
      return {
        ...initialState,
        dateRange: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
